import { CREATE_ORG_TRANSLATION_TRANSLATIONS } from "../translations/util";

export {
  ORGANIZATION_TABLE_HEADERS,
  ORGANIZATION_MAPPING_TABLE_HEADERS,
  ORGANIZATION_TRANSLATION_TABLE_HEADERS,
  LOCATIONS_TABLE_HEADERS,
  XSSI_TABLE_HEADERS,
  OTAR_TABLE_HEADERS,
  CANNED_MESSAGES_TABLE_HEADERS,
  LMR_USERS_TABLE_HEADERS,
  LMR_GROUPS_TABLE_HEADERS,
  MCPTT_USERS_TABLE_HEADERS,
  MCPTT_GROUPS_TABLE_HEADERS,
  DFSI_CONNECTIONS_TABLE_HEADERS,
  DFSI_CHANNELS_TABLE_HEADERS,
  DFSI_GROUPS_TABLE_HEADERS,
  FIXED_NETWORK_ELEMENT_TABLE_HEADERS,
  ALARM_TABLE_HEADERS,
  FAULTS_TABLE_HEADERS,
  INVENTORY_TABLE_HEADERS,
  INSTANCES_TABLE_HEADERS,
  HISTORICAL_ALARM_TABLE_HEADERS,
  P25_UNIT_TABLE_HEADERS,
  REALTIME_TABLE_HEADERS,
  P25_GROUP_TABLE_HEADERS,
  P25_AFFILIATIONS_TABLE_HEADERS,
} from "./tableHeaders";

export {
  ADD_XSSI_CONNECTION_FORM_FIELDS,
  ADD_DFSI_GROUP_FORM_FIELDS,
  ADD_DFSI_CHANNEL_FORM_FIELDS,
  ADD_DFSI_CONNECTION_FORM_FIELDS,
  ADD_LOCATIONS_FORM_FIELDS,
  ADD_ORGANIZATION_MAPPING_FORM_FIELDS,
  ADD_ORGANIZATION_FORM_FIELDS,
  ADD_CANNED_MESSAGES_FORM_FIELDS,
  ADD_LMR_GROUPS_FORM_FIELDS,
  ADD_LMR_USERS_FORM_FIELDS,
  ADD_MCPTT_GROUPS_FORM_FIELDS,
  ADD_MCPTT_USER_FORM_FIELDS,
  ADD_OTAR_CONNECTION_FORM_FIELDS,
} from "./addFormFields";

export {
  EDIT_XSSI_CONNECTION_FORM_FIELDS,
  EDIT_OTAR_CONNECTION_FORM_FIELDS,
  EDIT_MCPTT_USER_FORM_FIELDS,
  EDIT_MCPTT_GROUPS_FORM_FIELDS,
  EDIT_LMR_USERS_FORM_FIELDS,
  EDIT_LMR_GROUPS_FORM_FIELDS,
  EDIT_CANNED_MESSAGES_FORM_FIELDS,
  EDIT_REALTIME_PUBLISH_INFO_FORM_FIELDS,
  EDIT_ORGANIZATION_FORM_FIELDS,
  EDIT_LOCATIONS_FORM_FIELDS,
  EDIT_ORGANIZATION_MAPPING_FORM_FIELDS,
  EDIT_ORGANISATION_TRANSLATION_FORM_FIELDS,
  EDIT_DFSI_CONNECTION_FORM_FIELDS,
  EDIT_DFSI_CHANNEL_FORM_FIELDS,
  EDIT_LMR_GROUP_PROFILE_FORM_FIELDS,
  EDIT_MCPTT_GROUP_PROFILE_FORM_FIELDS,
} from "./editFormFields";

export {
  VIEW_P25_UNIT_FORM_FIELDS,
  VIEW_FAULTS_FORM_FIELDS,
  VIEW_INSTANCE_FORM_FIELDS,
  VIEW_FIXED_NETWORK_ELEMENT_FORM_FIELDS,
  VIEW_INVENTORY_FORM_FIELDS,
  VIEW_HISTORICAL_ALARMS_FORM_FIELDS,
  VIEW_ALARMS_FORM_FIELDS,
  VIEW_P25_GROUP_FORM_FIELDS,
} from "./viewFormFields";

export {
  XSSI_FILTER_COLUMNS,
  LMR_GROUPS_FILTER_COLUMNS,
  DFSI_CONNECTIONS_FILTER_COLUMNS,
  LMR_USERS_FILTER_COLUMNS,
  MCPTT_GROUPS_FILTER_COLUMNS,
  MCPTT_USERS_FILTER_COLUMNS,
  OTAR_FILTER_COLUMNS,
  CANNED_MESSAGES_FILTER_COLUMNS,
  ORGANIZATION_FILTER_COLUMNS,
  ORGANIZATION_TRANSLATION_FILTER_COLUMNS,
  ORGANIZATION_MAPPING_FILTER_COLUMNS,
  FIXED_NETWORK_ELEMENT_FILTER_COLUMNS,
  LOCATIONS_FILTER_COLUMNS,
  P25_UNIT_FILTER_COLUMNS,
  REALTIME_FILTER_COLUMNS,
  P25_GROUP_FILTER_COLUMNS,
} from "./filterColumns";

export const API_URL =
  process.env.REACT_APP_ESLMR_API_URL || "http://localhost:4000";

export const APP_VERSION = "v4.1.12";
export const APP_NAME = "Etherstack";
export const XSSI_GROUP_RANGE_MAX_VALUE = 65535;
export const XSSI_UNIT_RANGE_MAX_VALUE = 16777215;
export const XSSI_RANGE_MIN_VALUE = 1;

export const fieldNameMapping: Record<string, string> = {
  "HOST-CONTROL-IPV4-ADDR": "Host Control IPV4 Address",
  "HOST-CONTROL-PORT": "Host Control Port",
  "HOST-VOICE-IPV4-ADDR": "Host Voice IPV4 Address",
  "VOICE-PORT": "Voice Port",
  "DATA-IPV4-ADDR": "Data IPV4 Address",
  "DATA-PORT": "Data Port",
  "FIXED-STATION-CONTROL-IPV4-ADDR": "Fixed Station Control IPV4 Address",
  "FIXED-STATION-VOICE-IPV4-ADDR": "Fixed Station Voice IPV4 Address",
  "FIXED-STATION-CONTROL-PORT": "Fixed Station Control Port",
};

export const ORG_TRANSLATION_ITEMS = [
  {
    id: "floor-control",
    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown.dropdownItems[
      "floor-control"
    ],
    disabled: true,
  },
  {
    id: "P25-TO-MC-FC-PRI",
    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown.dropdownItems[
      "P25-TO-MC-FC-PRI"
    ],
  },
  {
    id: "MC-TO-P25-FC-PRI",
    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown.dropdownItems[
      "MC-TO-P25-FC-PRI"
    ],
  },
  {
    id: "DMR-TO-MC-FC-PRI",
    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown.dropdownItems[
      "DMR-TO-MC-FC-PRI"
    ],
  },
  {
    id: "MC-TO-DMR-FC-PRI",
    text: CREATE_ORG_TRANSLATION_TRANSLATIONS.dropdown.dropdownItems[
      "MC-TO-DMR-FC-PRI"
    ],
  },
];
